import { Keyframe, WeightedMode } from "./Keyframe";
import { Vector2 } from "./Vector2";
export class Vector2Keyframe extends Keyframe {
    constructor(weightMode = false) {
        super();
        this.inTangent = new Vector2();
        this.outTangent = new Vector2();
        this.value = new Vector2();
        if (weightMode) {
            this.inWeight = new Vector2(Keyframe.defaultWeight, Keyframe.defaultWeight);
            this.outWeight = new Vector2(Keyframe.defaultWeight, Keyframe.defaultWeight);
            this.weightedMode = new Vector2(WeightedMode.None, WeightedMode.None);
        }
    }
    cloneTo(dest) {
        super.cloneTo(dest);
        this.inTangent.cloneTo(dest.inTangent);
        this.outTangent.cloneTo(dest.outTangent);
        this.value.cloneTo(dest.value);
        if (this.weightedMode) {
            this.inWeight.cloneTo(dest.inWeight);
            this.outWeight.cloneTo(dest.outWeight);
            this.weightedMode.cloneTo(dest.weightedMode);
        }
    }
}
